import * as React from "react"
import {Typography} from '@mui/material'

import {NotAllowedBlock} from "@components";


export default function priceAbsDiffColumn() {
    return {
        name: 'priceDiffAbs',
        label: 'Price Abs Diff',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => <Typography sx={{ fontSize: '0.875rem', textAlign: 'center' }}>
                { !!value ? value : <NotAllowedBlock /> }
            </Typography>
        }
    }
}